import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import moment from "moment-timezone";
import React from "react";

import { DateTime } from "../Date";

const useStyles = makeStyles(
  theme => ({
    avatar: {
      left: -45,
      position: "absolute",
      top: 0
    },
    card: {
      marginBottom: theme.spacing(3),
      marginLeft: theme.spacing(3),
      position: "relative"
    },
    cardContent: {
      "&:last-child": {
        padding: 16
      },
      boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.05)"
    },
    date: {
      color: theme.typography.caption.color
    },
    dot: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "100%",
      height: 8,
      left: -29,
      position: "absolute",
      top: 6,
      width: 8
    },
    root: {
      position: "relative"
    },
    title: {
      "& p": {
        fontSize: "14px"
      },
      display: "flex",
      justifyContent: "space-between",
      marginBottom: theme.spacing(),
      paddingLeft: theme.spacing(3),
      textAlign: "right"
    }
  }),
  { name: "TimelineNoteRemittanceProcessing" }
);

interface TimelineNoteProps {
  date: string;
  title: string | null;
  message: string | null;
  user: {
    email: string;
  };
}

const dateFormat = value => {
  const date = moment(value);
  return date.format("lll");
};

export const TimelineNoteRemittanceProcessing: React.FC<TimelineNoteProps> = props => {
  const { date, message, title } = props;

  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      <span className={classes.dot} />
      <div className={classes.title}>
        <Typography>{title}</Typography>
        <Typography className={classes.date}>
          <Typography>
            <DateTime date={date} />
          </Typography>
          <Typography>{dateFormat(date)}</Typography>
        </Typography>
      </div>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <Typography
            dangerouslySetInnerHTML={{
              __html: message.replace(/\n/g, "<br />")
            }}
          />
        </CardContent>
      </Card>
    </div>
  );
};
TimelineNoteRemittanceProcessing.displayName =
  "TimelineNoteRemittanceProcessing";
export default TimelineNoteRemittanceProcessing;
